<template>
  <div>
    <InputNumber v-model="fieldValue" :disabled="disabled"></InputNumber>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';

export default {
  name: "DynamicNumberInput",
  props: ['uniqueId', 'disabled'],
  data() {
    return {
      // fieldValue: ''
    }
  },
  computed: {
    ...mapGetters('search', [
      'getData'
    ]),
    fieldValue: {
      get() {
        let val = this.getData(this.uniqueId)[0];
        if (val === null || val === "") {
          val = 0;
          this.setData({uniqueId: this.uniqueId, data: [0]})
        }
        return val;
        // return this.getData(this.uniqueId);
      },
      set(data) {
        let val = data;
        if (val === null || val === "") {
          val = 0;
        }
        // this.setData({uniqueId: this.uniqueId, data: [data]})
        this.setData({uniqueId: this.uniqueId, data: [val]})
      }
    },


  },
  methods: {
    ...mapActions('search', [
      'setData'
    ]),
  },
}
</script>

<style scoped>

</style>